/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientActionLogDto } from '../../models/client-action-log-dto';

export interface ClientActionLogControllerFindById$Params {
  id: string;
}

export function clientActionLogControllerFindById(http: HttpClient, rootUrl: string, params: ClientActionLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientActionLogDto>> {
  const rb = new RequestBuilder(rootUrl, clientActionLogControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientActionLogDto>;
    })
  );
}

clientActionLogControllerFindById.PATH = '/api/clientActionLog/{id}';
